import type React from 'react';

import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';

import { StyledMeetingPrepText, StyledMeetingPrepButton, StyledLink } from './styles';

type Props = {
  domain: string;
};

export const MeetingPrepButton: React.FC<Props> = ({ domain }) => {
  const { t } = useTranslation();

  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleClick = () => {
    dispatchTrackEventWithLocation('meeting prep agent', 'click', `meeting prep ext button/${domain}`);
  };

  return (
    <div>
      <StyledLink
        href={`https://pro.similarweb.com/#/sales/ai-meeting-agent/chat/${domain}`}
        target={'_blank'}
        rel="noreferrer"
        onMouseDown={handleClick}
      >
        <StyledMeetingPrepButton onClick={handleClick} variant="ghost" data-automation="meeting-prep-button">
          <SWReactIcons iconName="ai-calendar" size="xs" iconColor={colorsPalettes.blue[350]} />
          <StyledMeetingPrepText>{t('company.overview.meeting-prep.button')}</StyledMeetingPrepText>
        </StyledMeetingPrepButton>
      </StyledLink>
    </div>
  );
};
